import { Navigate, Route } from "react-router-dom";

function pickPortalSession() {
  try {
    if (localStorage.getItem("naturals_partner_userId")) return "partner";
    if (localStorage.getItem("naturals_executive_userId")) return "executive";
    if (localStorage.getItem("naturals_workspace_userId")) return "workspace";
  } catch {
    /* ignore */
  }
  return "workspace";
}

function LegacyMappedRedirect({ map }) {
  const portal = pickPortalSession();
  const to = map[portal] || map.workspace || map.executive || map.partner;
  return <Navigate to={to} replace />;
}

const PATH_MAP = {
  "/nyafaz-ep/salon-admin/super-admin-dashboard": {
    executive: "/nyafaz-ep/executive/super-admin-dashboard",
    workspace: "/nyafaz-ep/workspace/admin-dashboard",
    partner: "/nyafaz-ep/partner/ib-dashboard",
  },
  "/nyafaz-ep/salon-admin/hq-admins": {
    executive: "/nyafaz-ep/executive/hq-admins",
    workspace: "/nyafaz-ep/workspace/admin-dashboard",
    partner: "/nyafaz-ep/partner/ib-dashboard",
  },
  "/nyafaz-ep/salon-admin/admin-dashboard": {
    workspace: "/nyafaz-ep/workspace/admin-dashboard",
    executive: "/nyafaz-ep/executive/super-admin-dashboard",
    partner: "/nyafaz-ep/partner/ib-dashboard",
  },
  "/nyafaz-ep/salon-admin/ib-dashboard": {
    partner: "/nyafaz-ep/partner/ib-dashboard",
    workspace: "/nyafaz-ep/workspace/admin-dashboard",
    executive: "/nyafaz-ep/executive/super-admin-dashboard",
  },
  "/nyafaz-ep/salon-admin/check-ins": { partner: "/nyafaz-ep/partner/check-ins" },
  "/nyafaz-ep/salon-admin/check-in-analytics": { partner: "/nyafaz-ep/partner/check-in-analytics" },
  "/nyafaz-ep/salon-admin/my-orders": { partner: "/nyafaz-ep/partner/my-orders" },
  "/nyafaz-ep/salon-admin/kiosk-login": { partner: "/nyafaz-ep/partner/kiosk-login" },
  "/nyafaz-ep/salon-admin/store-location": { partner: "/nyafaz-ep/partner/store-location" },
  "/nyafaz-ep/salon-admin/kiosk-landings": { workspace: "/nyafaz-ep/workspace/kiosk-landings" },
  "/nyafaz-ep/salon-admin/kiosk-register-forms": { workspace: "/nyafaz-ep/workspace/kiosk-register-forms" },
  "/nyafaz-ep/salon-admin/kiosk-terms": { workspace: "/nyafaz-ep/workspace/kiosk-terms" },
  "/nyafaz-ep/salon-admin/page-setup": { workspace: "/nyafaz-ep/workspace/page-setup" },
  "/nyafaz-ep/salon-admin/skin-analysis-settings": { workspace: "/nyafaz-ep/workspace/skin-analysis-settings" },
  "/nyafaz-ep/salon-admin/productlist": { workspace: "/nyafaz-ep/workspace/productlist" },
  "/nyafaz-ep/salon-admin/servicelist": { workspace: "/nyafaz-ep/workspace/servicelist" },
  "/nyafaz-ep/salon-admin/franchise-users": { workspace: "/nyafaz-ep/workspace/franchise-users" },
  "/nyafaz-ep/salon-admin/whatsapp-credentials": { workspace: "/nyafaz-ep/workspace/whatsapp-credentials" },
  "/nyafaz-ep/salon-admin/admin-contact-messages": { workspace: "/nyafaz-ep/workspace/admin-contact-messages" },
  "/nyafaz-ep/salon-admin/company-profile": {
    workspace: "/nyafaz-ep/workspace/company-profile",
    executive: "/nyafaz-ep/executive/company-profile",
  },
  "/nyafaz-ep/salon-admin/complaints": {
    partner: "/nyafaz-ep/partner/complaints",
    executive: "/nyafaz-ep/executive/complaints",
    workspace: "/nyafaz-ep/workspace/admin-dashboard",
  },
  "/nyafaz-ep/salon-admin/naturals-kpis": {
    partner: "/nyafaz-ep/partner/naturals-kpis",
    executive: "/nyafaz-ep/executive/naturals-kpis",
    workspace: "/nyafaz-ep/workspace/admin-dashboard",
  },
  "/nyafaz-ep/salon-admin/store-location-requests": {
    workspace: "/nyafaz-ep/workspace/store-location-requests",
  },
  "/nyafaz-ep/salon-admin/edit-profile": {
    workspace: "/nyafaz-ep/workspace/edit-profile",
    executive: "/nyafaz-ep/executive/edit-profile",
    partner: "/nyafaz-ep/partner/edit-profile",
  },
};

export function renderSalonAdminLegacyRedirects() {
  return (
    <>
      <Route path="/nyafaz-ep/salon-admin" element={<Navigate to="/nyafaz-ep/workspace" replace />} />
      <Route path="/nyafaz-ep/super-admin" element={<Navigate to="/nyafaz-ep/executive" replace />} />
      <Route path="/nyafaz-ep/franchise-admin" element={<Navigate to="/nyafaz-ep/partner" replace />} />
      {Object.entries(PATH_MAP).map(([from, map]) => (
        <Route key={from} path={from} element={<LegacyMappedRedirect map={map} />} />
      ))}
      <Route
        path="/nyafaz-ep/salon-admin/*"
        element={<Navigate to="/nyafaz-ep/workspace" replace />}
      />
    </>
  );
}

/** @deprecated Use renderSalonAdminLegacyRedirects */
export function renderSalonAdminRoutes() {
  return renderSalonAdminLegacyRedirects();
}
